import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Generic, content-shape skeleton placeholder for row-based lists/tables.
 * Built on the app-wide `db-skeleton-*` token system (shimmer, reduced-motion,
 * high-contrast already handled there) rather than introducing new styling.
 */
@Component({
    selector: 'app-skeleton-loader',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.scss'],
})
export class SkeletonLoaderComponent {
    /** Number of placeholder rows to render. */
    @Input() rows = 5;

    /** Number of skeleton bar segments per row (approximates column count). */
    @Input() columns = 4;

    /** Renders a second, shorter bar under each segment — for two-line cells (e.g. name + subtext). */
    @Input() linesPerColumn: 1 | 2 = 1;

    /** Renders a circular placeholder (avatar/logo/icon) at the start of each row. */
    @Input() showLeadingIcon = false;

    /** Screen-reader-only text announced once via the shared live region. Override per consumer for context. */
    @Input() label = 'Loading content, please wait';

    protected get rowRange(): number[] {
        return Array.from({ length: this.rows });
    }

    protected get columnRange(): number[] {
        return Array.from({ length: this.columns });
    }
}
